'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YouTube = (_temp = _class = function (_SvgIcon) {
  _inherits(YouTube, _SvgIcon);

  function YouTube() {
    _classCallCheck(this, YouTube);

    return _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).apply(this, arguments));
  }

  _createClass(YouTube, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'youtube-icon', transform: 'translate(6.000000, 14.000000)' },
            _react2['default'].createElement('path', {
              fill: '#FF0000',
              transform: 'translate(0.000000, 0.057371)',
              d: 'M0.246460392,10.7192534 C0.577762353,5.57500618 4.56336235,1.41946966 9.68576039,0.870809551 C14.9989584,0.335452809 20.6461604,0.0466241573 26.4999584,0.0466241573 C32.3538604,0.0466241573 38.0009584,0.335452809 43.3142604,0.873511798 C48.4366584,1.41946966 52.4223624,5.57500618 52.7535604,10.7192534 C52.9151584,13.2529219 52.9999584,15.8422983 52.9999584,18.471273 C52.9999584,21.1003517 52.9151584,23.6897281 52.7535604,26.2233966 C52.4223624,31.3675399 48.4366584,35.5232843 43.3142604,36.0718404 C38.0009584,36.6070933 32.3538604,36.8961298 26.4999584,36.8961298 C20.6461604,36.8961298 14.9989584,36.6070933 9.68576039,36.0692421 C4.56336235,35.5232843 0.577762353,31.3675399 0.246460392,26.2233966 C0.0847584314,23.6897281 -4.15686275e-05,21.1003517 -4.15686275e-05,18.471273 C-4.15686275e-05,15.8422983 0.0847584314,13.2529219 0.246460392,10.7192534'
            }),
            _react2['default'].createElement('polygon', {
              fill: '#FFFFFF',
              points: '34.5957292 18.5286854 21.5869312 26.4662247 21.5869312 10.5910421'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return YouTube;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = YouTube;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/YouTube.js
// module id = 1417
// module chunks = 32